import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AsamcoUserService } from '@asamco/base';
import { Subject } from 'rxjs';
import { FunctionAppService } from '../services/function-app.service';
import { FunctionAppInstance } from '../interfaces/function-app-instance.interface';
import Swal from 'sweetalert2';
import { showErrorSwal } from '@asamco/utils';
import { DxiColumnModule, DxoFilterRowModule, DxoSelectionModule } from 'devextreme-angular/ui/nested';
import { DxDataGridModule } from 'devextreme-angular';
import { AsyncPipe, NgIf } from '@angular/common';

@Component({
	selector: 'durable-function-app-management',
	templateUrl: './durable-function-app-management.component.html',
	styleUrls: ['./durable-function-app-management.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [AsyncPipe, NgIf, DxiColumnModule, DxoFilterRowModule, DxoSelectionModule, DxDataGridModule]
})
export class DurableFunctionAppManagementComponent implements OnInit {
	public isAdminSubject = new Subject<boolean>();
	public isAdminObservable = this.isAdminSubject.asObservable();
	private instances: FunctionAppInstance[] = [];

	private dataSubject = new Subject<FunctionAppInstance[]>();
	public dataObservable = this.dataSubject.asObservable();

	constructor(private asamcoUserService: AsamcoUserService, private functionAppService: FunctionAppService) {}

	killInstance(e: FunctionAppInstance) {
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, terminate the instance',
		}).then(result => {
			if (result.isConfirmed) {
				this.functionAppService.terminateSingleInstanceNew(11, e.instanceId).subscribe(
					e => {
						Swal.fire('Terminated instance!', 'Successfully terminated instance.', 'success');
					},
					err => {
						Swal.fire('Error terminating instance', 'Unable to terminate instance.', 'error');
					}
				);
			}
		});
	}

	purgeHistory(e) {
		this.functionAppService.getDurableFunctionInstanceDataNew(11, e.instanceId).subscribe(
			e => {},
			err => showErrorSwal(err)
		);
	}

	retrieveData() {
		this.functionAppService.getDurableFunctionInstanceData().subscribe(
			(e: any[]) => {
				if (e) {
					e.forEach(item => {
						let functionAppInstance: FunctionAppInstance = {
							name: item.name,
							instanceId: item.instanceId,
							runtimeStatus: item.runtimeStatus,
							linkId: item.input?.LinkId,
							customStatus: item.customStatus,
							output: item.output,
							createdTime: item.createdTime,
							lastUpdatedTime: item.lastUpdatedTime,
						};
						this.instances.push(functionAppInstance);
					});
					this.dataSubject.next(this.instances);
				}
			},
			err => showErrorSwal(err)
		);
	}

	ngOnInit(): void {
		this.asamcoUserService.isAdmin().then(result => {
			this.isAdminSubject.next(result);
			this.retrieveData();
		});
	}
}
